import { gql } from "@apollo/client";

export const PET_CREATE = gql`
  mutation addAPetV2($pet: AddAPetRequestInputV2!, $file: Upload) {
    addAPetV2(
      file: $file,
      addAPetData: $pet,
    ) {
      pet {
        id,
        name,
        species,
        breed,
        birthdate,
        gender,
        isDesexed,
        medicalRecord {
          city,
          clinicName,
        }
      }
      success,
      messages
    }
  }`;
